(function () {
  'use strict';
  const bkwRoot = document.querySelector('.bkw-isolate.bkw-page');
  if (!bkwRoot) return;

// Power Dock tabs: lightweight (no Tailwind dependency)
  (function () {
    const root = document.getElementById('Diagram');
    if (!root) return;

    const duration = 5000;
    const interval = 50;

    const tabs = Array.from(root.querySelectorAll('.tab-trigger'));
    const panels = Array.from(root.querySelectorAll('.tab-content'));

    let currentTab = 0;
    let progress = 0;
    let timer;

    function setActive(index) {
      currentTab = index;

      tabs.forEach((tab, i) => {
        const active = i === currentTab;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');

        const title = tab.querySelector('.tab-title');
        if (title) title.classList.toggle('is-muted', !active);

        const fill = tab.querySelector('.progress-fill');
        if (fill) fill.style.width = active ? `${progress}%` : '0%';
      });

      panels.forEach((panel, i) => {
        const active = i === currentTab;
        panel.style.display = active ? 'block' : 'none';
        if (active) {
          panel.querySelectorAll('video').forEach((v) => {
            try {
              v.currentTime = 0;
              v.play().catch(() => {});
            } catch (_) {}
          });
        }
      });
    }

    function renderProgress() {
      tabs.forEach((tab, i) => {
        const fill = tab.querySelector('.progress-fill');
        if (!fill) return;
        fill.style.width = i === currentTab ? `${progress}%` : '0%';
      });
    }

    function startTimer() {
      clearInterval(timer);
      progress = 0;
      renderProgress();

      timer = setInterval(() => {
        progress += (interval / duration) * 100;

        if (progress >= 100) {
          progress = 0;
          setActive((currentTab + 1) % tabs.length);
        }

        renderProgress();
      }, interval);
    }

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        progress = 0;
        setActive(i);
        startTimer();
      });
    });

    setActive(0);
    startTimer();
  })();

const input = document.getElementById('yearUsage');
  const btn = document.getElementById('calcBtn');
  const daily = document.getElementById('dailyResult');
  const rec = document.getElementById('recommendation');
  function calc() {
    const val = Math.max(0, Number(input.value || 0));
    const d = val / 365;
    daily.textContent = d.toLocaleString('de-DE', { maximumFractionDigits: 1, minimumFractionDigits: 1 });
    if (d < 2) rec.textContent = 'Für diesen Bereich eignet sich ein kompaktes Einsteiger-Set mit kleinerem Speicher.';
    else if (d < 4) rec.textContent = 'Für diesen Bereich ist ein ausgewogenes Set mit 2.000 W Modulleistung und Speicher sinnvoll.';
    else if (d < 6) rec.textContent = 'Für diesen Bereich lohnt sich eine Lösung mit mehr Modulen und erweiterbarem Speicher.';
    else rec.textContent = 'Für diesen Bereich eignen sich größere Sets mit erweiterbarem Speicher und mehreren Modulen.';
  }
  if (btn) btn.addEventListener('click', calc);
  if (input) input.addEventListener('input', calc);
  if (input && daily) calc();

  const roiInputs = {
    investment: document.getElementById('roiTotalInvestment'),
    systemKw: document.getElementById('roiSystemKw'),
    sunHours: document.getElementById('roiSunHours'),
    efficiency: document.getElementById('roiEfficiency'),
    price: document.getElementById('roiElectricityPrice')
  };
  const roiOutputs = {
    paybackYears: document.getElementById('roiPaybackYears'),
    annualGeneration: document.getElementById('roiAnnualGeneration'),
    annualNetBenefit: document.getElementById('roiAnnualNetBenefit'),
    lossRate: document.getElementById('roiLossRate'),
    resultText: document.getElementById('roiResultText')
  };
  function formatNumber(value, digits = 0) {
    return value.toLocaleString('de-DE', { maximumFractionDigits: digits, minimumFractionDigits: digits });
  }
  function parseGermanNumber(value) {
    return Number(String(value || 0).replace(',', '.'));
  }
  function calcRoiSavings() {
    if (!roiInputs.investment || !roiInputs.systemKw || !roiInputs.sunHours || !roiInputs.efficiency || !roiInputs.price) return;

    const investment = Math.max(0, parseGermanNumber(roiInputs.investment.value));
    const systemKw = Math.max(0, parseGermanNumber(roiInputs.systemKw.value));
    const sunHours = Math.max(0, parseGermanNumber(roiInputs.sunHours.value));
    const efficiency = Math.max(0, Math.min(1, parseGermanNumber(roiInputs.efficiency.value)));
    const price = Math.max(0, parseGermanNumber(roiInputs.price.value));

    const annualGeneration = systemKw * sunHours * efficiency;
    const annualNetBenefit = annualGeneration * price;
    const paybackYears = annualNetBenefit > 0 ? investment / annualNetBenefit : 0;
    const lossRate = Math.max(0, (1 - efficiency) * 100);

    roiOutputs.paybackYears.textContent = annualNetBenefit > 0 ? formatNumber(paybackYears, 1) : '–';
    roiOutputs.annualGeneration.textContent = formatNumber(annualGeneration, 0);
    roiOutputs.annualNetBenefit.textContent = formatNumber(annualNetBenefit, 0);
    roiOutputs.lossRate.textContent = formatNumber(lossRate, 0);
    roiOutputs.resultText.textContent = `Bei den gewählten Werten erzeugt das System ca. ${formatNumber(annualGeneration, 0)} kWh pro Jahr. Daraus ergibt sich ein geschätzter jährlicher Nutzen von ${formatNumber(annualNetBenefit, 0)} €.`;
  }
  Object.values(roiInputs).forEach((el) => {
    if (el) el.addEventListener('input', calcRoiSavings);
  });
  calcRoiSavings();


  const productJsonCache = new Map();

  function parseRecoProductLink(href) {
    if (!href || href === '#' || href.startsWith('#')) return null;
    try {
      const url = new URL(href, window.location.origin);
      const productMatch = url.pathname.match(/\/products\/([^/?#]+)/);
      if (!productMatch) return null;
      const variantParam = url.searchParams.get('variant');
      return {
        handle: decodeURIComponent(productMatch[1]),
        variantId: variantParam ? Number(variantParam) : null
      };
    } catch {
      return null;
    }
  }

  function formatRecoPrice(cents) {
    const moneyFormat = window.theme?.settings?.moneyFormat;
    if (window.theme?.Currency?.formatMoney && moneyFormat) {
      return `ab ${window.theme.Currency.formatMoney(cents, moneyFormat)}`;
    }
    const amount = (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return `ab ${amount} €`;
  }

  function pickVariant(product, variantId) {
    const variants = product.variants || [];
    if (variantId) {
      const found = variants.find((v) => v.id === variantId);
      if (found) return found;
    }
    return variants.find((v) => v.available) || variants[0];
  }

  function fetchProductJson(handle) {
    if (productJsonCache.has(handle)) return productJsonCache.get(handle);
    const root = (window.theme?.routes?.root_url || '').replace(/\/$/, '');
    const url = `${root}/products/${encodeURIComponent(handle)}.js`;
    const promise = fetch(url).then((res) => {
      if (!res.ok) throw new Error(`Product ${handle}: ${res.status}`);
      return res.json();
    }).catch((err) => {
      productJsonCache.delete(handle);
      throw err;
    });
    productJsonCache.set(handle, promise);
    return promise;
  }

  function updateProductPrices(source) {
    const prices = source || window.productPriceData;
    if (!prices) return;
    bkwRoot.querySelectorAll('[data-price-id]').forEach((node) => {
      const id = node.getAttribute('data-price-id');
      const value = prices[id];
      if (value) node.textContent = typeof value === 'string' ? value : value.price;
    });
  }
  window.updateProductPrices = updateProductPrices;

  function loadRecoProductPrices() {
    const cards = bkwRoot.querySelectorAll('.reco-product-card');
    const tasks = [];

    cards.forEach((card) => {
      // 优先从reco-price的属性中取：
      //          变体id    data-variant-id="51325474472202"
      //          产品handle    data-product-handle="solarmars-balkonkraftwerk-..."
      const priceEl = card.querySelector('.reco-price[data-price-id]');
      if (!priceEl) return;

      const variantIdAttr = priceEl.getAttribute('data-variant-id');
      const handleAttr = priceEl.getAttribute('data-product-handle');
      const parsed = parseRecoProductLink(card.getAttribute('href'));
      const handle = handleAttr || parsed?.handle;
      const variantId = variantIdAttr ? Number(variantIdAttr) : parsed?.variantId;
      if (!handle) return;

      tasks.push(
        fetchProductJson(handle)
          .then((product) => {
            const variant = pickVariant(product, variantId);
            if (!variant) return;
            priceEl.textContent = formatRecoPrice(variant.price);
          })
          .catch(() => {})
      );
    });

    return Promise.all(tasks);
  }
  window.loadRecoProductPrices = loadRecoProductPrices;
  loadRecoProductPrices();


  // Back to top (desktop)
  const toTop = document.querySelector('.to-top');
  if (toTop) {
    const toggleToTop = () => {
      const shouldShow = window.scrollY > 700;
      toTop.classList.toggle('is-visible', shouldShow);
    };
    window.addEventListener('scroll', toggleToTop, { passive: true });
    toggleToTop();
    toTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

(function () {
  const storyCards = Array.from(document.querySelectorAll('#user-stories details.user-story-card'));
  if (!storyCards.length) return;

  storyCards.forEach((card) => {
    card.addEventListener('toggle', () => {
      if (!card.open) return;

      storyCards.forEach((other) => {
        if (other !== card) other.open = false;
      });

      if (window.matchMedia('(max-width: 760px)').matches) {
        window.setTimeout(() => {
          card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 80);
      }
    });
  });
})();

(function () {
  const lightbox = document.getElementById('imageLightbox');
  if (!lightbox) return;

  const stage = lightbox.querySelector('.image-lightbox-stage');
  const lightboxImg = lightbox.querySelector('img');
  const closeBtn = lightbox.querySelector('.image-lightbox-close');

  function openLightbox(img) {
    if (!img || !window.matchMedia('(max-width: 760px)').matches) return;
    lightboxImg.src = img.currentSrc || img.src;
    lightboxImg.alt = img.alt || 'Vergrößerte Bildansicht';
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bkw-lightbox-lock');

    window.setTimeout(function () {
      if (stage && window.matchMedia('(max-width: 760px)').matches) {
        stage.scrollLeft = Math.max(0, (stage.scrollWidth - stage.clientWidth) / 2);
        stage.scrollTop = 0;
      }
    }, 60);
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bkw-lightbox-lock');
    lightboxImg.removeAttribute('src');
  }

  document.querySelectorAll('.image-frame, .mount-image, .topic-visual, .dc-image-slot').forEach(function (frame) {
    const img = frame.querySelector('img');
if (img) {
      img.addEventListener('click', function () {
        openLightbox(img);
      });
    }
});

  closeBtn.addEventListener('click', closeLightbox);

  lightbox.addEventListener('click', function (event) {
    if (event.target === lightbox) closeLightbox();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && lightbox.classList.contains('is-open')) {
      closeLightbox();
    }
  });
})();

(function () {
  const grid = document.querySelector('#user-stories .user-story-grid');
  const cards = Array.from(document.querySelectorAll('#user-stories details.user-story-card'));
  if (!grid || !cards.length) return;

  const desktop = window.matchMedia('(min-width: 761px)');

  function resetSpace() {
    grid.style.setProperty('--story-dropdown-space', '0px');
  }

  function updateSpace(card) {
    if (!desktop.matches || !card || !card.open) {
      resetSpace();
      return;
    }

    const detail = card.querySelector('.story-detail');
    if (!detail) {
      resetSpace();
      return;
    }

    window.requestAnimationFrame(function () {
      const height = detail.scrollHeight;
      grid.style.setProperty('--story-dropdown-space', (height + 36) + 'px');
    });
  }

  function closeOthers(active) {
    cards.forEach(function (card) {
      if (card !== active) card.open = false;
    });
  }

  document.addEventListener('click', function (event) {
    const summary = event.target.closest('#user-stories details.user-story-card > summary');
    if (!summary || !desktop.matches) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const card = summary.parentElement;
    const willOpen = !card.open;

    closeOthers(card);
    card.open = willOpen;

    if (willOpen) updateSpace(card);
    else resetSpace();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (!desktop.matches || (event.key !== 'Enter' && event.key !== ' ')) return;

    const summary = event.target.closest && event.target.closest('#user-stories details.user-story-card > summary');
    if (!summary) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const card = summary.parentElement;
    const willOpen = !card.open;

    closeOthers(card);
    card.open = willOpen;

    if (willOpen) updateSpace(card);
    else resetSpace();
  }, true);

  window.addEventListener('resize', function () {
    const opened = cards.find(function (card) { return card.open; });
    if (desktop.matches && opened) updateSpace(opened);
    if (!desktop.matches) resetSpace();
  });
})();
})();
